import { io, Socket } from "socket.io-client";

// ----------------------------- Base Urls ----------------------------------
const SOCKET_SERVER_URL = process.env["REACT_APP_SERVER_SOCKET_URL"]  // Backend URL

export const initializeSocket = (user_uuid: string): Socket => {
    const app_socket = io(SOCKET_SERVER_URL, {
        autoConnect: false, // Prevent automatic connection
        auth: {
            user_uuid // Send user_uuid uuid
        },
        // transports: ["polling", "websocket"], // fallback, // skip long-polling if your server allows
        // reconnectionAttempts: 3,   // limit noisy retries
        // timeout: 8000,             // ms before “connect_error”
    });
    app_socket.connect();
    return app_socket;
};


// const disconnectSocket = () => {
//     if (app_socket) {
//         app_socket.disconnect();
//         app_socket = null;
//     }
// };
